import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Call4UService } from '../../services/call4u.service';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'call4u-activate-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class Call4UPopupComponent implements OnInit, AfterViewInit {
  @ViewChild('modalSequenceCall', {static: true}) modalSequenceCall: ElementRef<any>;
  @Input() onClose: CallableFunction;
  @Output() activated = new EventEmitter<boolean>();

  activating = false;
  modalRef: any;

  constructor(
    private modalService: NgbModal,
    private Call4UService: Call4UService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.new(this.modalSequenceCall);
  }

  new(modal: any) {
    this.modalRef = this.modalService.open(modal, {size: 'lg'});
    this.modalRef.result.then(() => {
      // Modal closed via close() — ativação concluída
    },
    () => {
      if (this.onClose) {
        this.onClose(false);
      }
    });
  }

  next() {
    this.activating = true;
    this.Call4UService.activate().subscribe((response) => {
      this.activating = false;

      if (!response || !response.status) {
        const message = response?.message ?? 'Não foi possível ativar. Tente novamente.';
        this.modalService.dismissAll();
        return this.toastService.error(message);
      }

      this.toastService.success(response.message);
      this.activated.emit(true);
      this.modalRef.close();
    }, () => {
      this.activating = false;
      this.toastService.error('Erro ao ativar chamadas de voz. Tente novamente.');
    });
  }

  ngAfterViewInit(): void {
    // After
  }
}
